import { createSlice } from "@reduxjs/toolkit";
import { campDetailsByIdAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const campDetailByIdSlice = createSlice({
  name: "campDetailById",
  initialState: data,
  reducers: {
    campDetailByIdSlice(state) {
      state.isLoading = true;
    },
    campDetailByIdSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    campDetailByIdSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    campDetailByIdSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});
export const campDetailByIdByIdHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(campDetailByIdAction.campDetailByIdSlice());
    const response: any = await campDetailsByIdAPI(id);
    dispatch(campDetailByIdAction.campDetailByIdSliceSuccess(response));
  } catch (e: any) {
    dispatch(campDetailByIdAction.campDetailByIdSliceFailure(e?.response?.data?.message));
    dispatch(campDetailByIdAction.campDetailByIdSliceReset());
  }
};
export default campDetailByIdSlice.reducer;
export const campDetailByIdAction = campDetailByIdSlice.actions;